import axios from './axiosClient'
import * as _ from './config'

export const isShow = function (newVal) {
    newVal == true ? show() : hide();
}
export async function login(self) {

    $('.error-message').html('');
    //self.$emit('showLoading', true);
    _.ShowLoadingPane(self, true);
    var promise = await axios.post('/api/Auth/Login', self.$data.userInfo);
    loginSuccessfully(promise.data, self);
};



var loginSuccessfully = function (data, self) {
    //self.$emit('showLoading', false);
    _.ShowLoadingPane(self, false);
    if (data.IsSuccess) {
        $('#loginModal').modal('toggle');
        if (data.ReturnURL !== '') {
            window.open(data.ReturnURL, '_blank');
        }
        self.$emit('afterLogin', { userInfo: self.userInfo });
        setCookie('SMIHub', 'SMIHub', 5);
        location.reload();

    } else {
        $('.error-message').html(data.Message);
    }
};
var setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

var show = function () {
    $('#loginModal').modal({ backdrop: 'static', keyboard: false });
    $('#loginModal').show();
    $('#loginModal').modal();
};

var hide = function () {
    $('#loginModal').hide();
}